import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "flex-start",
    minHeight: theme.spacing(6),
  },
  backButton: { color: theme.palette.grey[600] },
}));

export default function PlanDiscoveryDialog({ activeStep, goBack }) {
  const classes = useStyles();

  return (
    <DialogActions className={classes.root}>
      {activeStep > 1 && (
        <Button
          startIcon={<KeyboardArrowLeftIcon />}
          className={classes.backButton}
          id="plan-discovery-back"
          onClick={goBack}
        >
          Back
        </Button>
      )}
    </DialogActions>
  );
}
